// src/App.js

import React from "react";
import ChatWidget from "./components/ChatWidget";

function App() {
  // Lê o objeto de configuração global injetado pelo WordPress.
  const config = window.chatWidgetConfig || {};

  return (
    <div>
      <ChatWidget
        // As configurações vêm do WordPress. Usamos valores padrão como segurança.
        chatflowid={config.chatflowid || "dbf534ef-9350-47ac-8e0f-30d7c3bdf6dc"}
        apiHost={config.apiHost || "https://flow-treinamentos.engehallsst.com.br"}
        headerTitle={config.headerTitle || ""}
        initialMessage={config.initialMessage || "Olá! Como posso ajudar?"}
        enableAudio={config.enableAudio ?? true}
        enableFeedback={config.enableFeedback ?? true}
        contextVars={config.contextVars || {}}
        theme={config.theme || {
          primary: "#FF7A01",
          accent: "#29C06F",
          background: "#222A32",
        }}
      />
    </div>
  );
}

export default App;